// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedList{
width: 200px;
}

.AnimatedList_item{
    border: 1px solid #000;

}

.AnimatedList_item--create{
    animation: AnimatedList_item--create forwards 1s;
}

.AnimatedList_item--delete{
    animation: AnimatedList_item--delete forwards 1s;
}

@keyframes AnimatedList_item--delete{
    0%{
        transform: scale(1);
    }
    100%{
        transform: scale(0);
    }
}

@keyframes AnimatedList_item--create{
    0%{
        transform: translate(-100%);
    }
    100%{
        transform: translate(0%);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/desktopPage/AnimatedList.css"],"names":[],"mappings":"AAAA;AACA,YAAY;AACZ;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".AnimatedList{\nwidth: 200px;\n}\n\n.AnimatedList_item{\n    border: 1px solid #000;\n\n}\n\n.AnimatedList_item--create{\n    animation: AnimatedList_item--create forwards 1s;\n}\n\n.AnimatedList_item--delete{\n    animation: AnimatedList_item--delete forwards 1s;\n}\n\n@keyframes AnimatedList_item--delete{\n    0%{\n        transform: scale(1);\n    }\n    100%{\n        transform: scale(0);\n    }\n}\n\n@keyframes AnimatedList_item--create{\n    0%{\n        transform: translate(-100%);\n    }\n    100%{\n        transform: translate(0%);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
